module.exports = __webpack_public_path__ + "media/title_mob_2.d48366f4.mp4";